module.exports = __webpack_public_path__ + "img/vip-icon3.6d14c189.png";